<template>
    <div :class="['techVideo']">  
<!--       {{this.sectionIndex}}
      <br/><br/><br/><br/>
      compData= {{compData}}
 -->      <!-- {{componentData}} -->
      <!-- componentData={{compData.content}} -->
        <div class="tvWrapper">
          <div class="tvVideo" v-html="compData.content"></div>
        </div>

    </div>
</template>


<!--              
<!--               <iframe 
                src="https://player.vimeo.com/video/1033482433" 
                style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" 
                frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="">
              </iframe>              
 -->          
-->

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";

export default {
    name: "techVideo",
    components:{},
    props: {
        sectionType:String,
        sectionIndex:Number,
        visible:Boolean,
        sectionDataIndex:Number,
        isNavOpen: Boolean,
        componentData:Object
    },
    data()
    {
        return {
            plaformIndex:-1,
            infoImg:'',
            isTechFadeout:true,
            compData:[]
        }
    },
    watch: {
    },
    mounted()
    {
      this.compData = this.getSiteTechTabData();
    },
    methods:
    {
      getSiteTechTabData()
      {
        var pageSections = this.pageLayoutData.children[0].children;        
        var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
        var targetNodes = techTabsSection[0].children[0].children;
        var targetNode = targetNodes[this.sectionIndex];//.filter(x => x.template == this.sectionType)[0];
        return targetNode;
      },
      onItemChange(catalogNo)
      {
        //nothing
      },
    },
    computed:{
        ...mapState(["pageLayoutData","xSelectedPlatform","minisite_data","siteDataReady"]),
        sectionData(){
            return "";//this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};
</script>


<style>
    .techVideo
    {
        background: transparent;
        width: 100%;
        height: 100%;   
        position: relative;     
        display: flex;        
    }    
    .techVideo.visible
    {
      display: block;
    }
    .tvWrapper
    {
      width: 100vw;
    }
    .tvVideo
    {
        position: relative;
        height: 40vw;
        width: calc(100% - 6vw);
        margin: auto;
        opacity: 1;
    }


  @media (hover: hover) {
  }

  @media (max-width: 850px) { 


  }  
</style>